import { RouteObject, createBrowserRouter } from "react-router-dom"
import { AdminUsersScreen } from "~/admin/admin-users-screen"
import { AdminAdminUsersScreen } from "~/admin/admin-admin-users-screen"
import { CreateAdminScreen } from "~/admin/create-admin-screen"
import { AdminUserProfileScreen } from "~/admin/admin-user-profile-screen"
import { AdminInviteLinksScreen } from "~/admin/admin-invite-links-screen"
import {
  RequireSystemAdminSignedIn,
  RequireUserActive,
  RequireUserOnboarding,
  RequireUserSignedOut,
} from "~/auth/auth-layouts"
import { LoginLayout } from "~/auth/login-layout"
import {
  contactsPath,
  credentialsLoginPath,
  dashboardPath,
  emailAuthPath,
  handlePath,
  invitationsPath,
  invitationLoginPath,
  loginPath,
  onboardingAccountDetailsPath,
  onboardingVerifyEmailPath,
  onboardingVerifyPhonePath,
  rootPath,
} from "~/common/paths"
import { OnboardingLayout } from "~/layouts/onboarding-layout"
import { TopNavLayout } from "~/layouts/top-nav-layout"
import { SidebarLayout } from "~/layouts/sidebar-layout"
import { CredentialsLoginScreen } from "~/login/credentials-login-screen"
import { EmailAuthScreen } from "~/login/email-auth-screen"
import { SolanaLoginScreen } from "~/login/solana-login-screen"
import { OnboardingAccountDetailsScreen } from "~/onboarding/onboarding-account-details-screen"
import { OnboardingVerifyEmailScreen } from "~/onboarding/onboarding-verify-email-screen"
import { OnboardingVerifyPhoneScreen } from "~/onboarding/onboarding-verify-phone-screen"
import { HandleProfileScreen } from "~/profile/handle-profile-screen"
import { DashboardScreen } from "~/dashboard/dashboard-screen"
import { InvitationsScreen } from "~/invitations/invitations-screen"
import { ContactsScreen } from "~/contacts/contacts-screen"
import { InvitationLoginScreen } from "~/invitation/invitation-login-screen"
import { ErrorBoundary } from "../ui/error-boundary"
import { RootLayout } from "./root-layout"
import { RootScreen } from "./root-screen"

const systemAdminAuthenticatedRoutes: Array<RouteObject> = [
  {
    path: "users",
    element: <AdminUsersScreen />,
  },
  {
    path: "admin-users",
    element: <AdminAdminUsersScreen />,
  },
  {
    path: "admin-users/create",
    element: <CreateAdminScreen />,
  },
  {
    path: "users/:userId",
    element: <AdminUserProfileScreen />,
  },
  {
    path: "invite-links",
    element: <AdminInviteLinksScreen />,
  },
]

const authenticatedRoutes: Array<RouteObject> = [
  {
    path: dashboardPath.pattern,
    element: <DashboardScreen />,
  },
  {
    path: invitationsPath.pattern,
    element: <InvitationsScreen />,
  },
  {
    path: contactsPath.pattern,
    element: <ContactsScreen />,
  },
  {
    path: handlePath.pattern,
    element: <HandleProfileScreen />,
  },
]

const authenticatedOnboardingRoutes: Array<RouteObject> = [
  {
    path: onboardingVerifyEmailPath.pattern,
    element: <OnboardingVerifyEmailScreen />,
  },
  {
    path: onboardingVerifyPhonePath.pattern,
    element: <OnboardingVerifyPhoneScreen />,
  },
  {
    path: onboardingAccountDetailsPath.pattern,
    element: <OnboardingAccountDetailsScreen />,
  },
]

export const router = createBrowserRouter([
  {
    path: "/",
    element: <RootLayout />,
    errorElement: <ErrorBoundary />,
    children: [
      {
        path: "/admin",
        element: <RequireSystemAdminSignedIn />,
        children: [
          {
            element: <SidebarLayout />,
            children: systemAdminAuthenticatedRoutes,
          },
        ],
      },
      {
        element: <RequireUserOnboarding />,
        children: [
          {
            element: <OnboardingLayout />,
            children: authenticatedOnboardingRoutes,
          },
        ],
      },
      {
        element: <RequireUserActive />,
        children: [
          {
            element: <TopNavLayout />,
            children: authenticatedRoutes,
          },
        ],
      },
      {
        element: <RequireUserSignedOut />,
        children: [
          {
            element: <OnboardingLayout />,
            children: [
              {
                path: loginPath.pattern,
                element: <SolanaLoginScreen />,
              },
            ],
          },
          {
            element: <LoginLayout />,
            children: [
              {
                path: credentialsLoginPath.pattern,
                element: <CredentialsLoginScreen />,
              },
              {
                path: emailAuthPath.pattern,
                element: <EmailAuthScreen />,
              },
            ],
          },
        ],
      },
      {
        element: <OnboardingLayout />,
        children: [
          {
            path: invitationLoginPath.pattern,
            element: <InvitationLoginScreen />,
          },
        ],
      },
      {
        path: rootPath.pattern,
        element: <RootScreen />,
      },
    ],
  },
])
